import axios from 'axios';
import _ from 'lodash';

import cfg from '../config';

export const JOBS_GET_JOBS = "jobs/GET_JOBS";

const initialState = {
  jobs: [],
  timestamp: Date.now(),
  running: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case JOBS_GET_JOBS:
      return {
        ...state,
        jobs: _.cloneDeep(action.data),
        timestamp: Date.now()
      }
    default:
      return state
  }
}

export const getJobs = () => {
  return (dispatch, getState) => {
    axios.get(cfg.api.getJobs)
    .then((response) => {
      dispatch({type: JOBS_GET_JOBS, data: response.data.jobs });
    })
    .catch((error) => {
      console.log(error);
      dispatch({type: JOBS_GET_JOBS, data: []});
    });
  }
}



// WEBPACK FOOTER //
// ./src/reducers/jobs.js